import Button from '../newButton/Button'
import styles from './ComingSoon.module.scss'
export default function ComingSoon ({ breed, isMobile }) {
  return (
    <div className={styles.background}>
      <h2>{breed} puppies coming soon!</h2>
      {/* <p>We have new puppies added every day, and would be thrilled to notify you as more {breed} puppies become available. </p> */}
      <p>We have new puppies added every day! Please check back too see if {breed} puppies are available or explore our related breeds selection below to find other similar pups!</p>

      <Button
        title='Notify Me'
        leftImage={isMobile ? null : '/search/bell-white.svg'}
        theme={['medium', 'pink-solid']}
      />
    </div>
  )
}
